import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var StoreIcon = function StoreIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 18v-5.25h-2.25V18H15zm1.5 0H21V6H3v12h4.5v-6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v6zM9 18h2.25v-5.25H9V18zm.75-10.5h4.5a.75.75 0 1 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5zM3 4.5h18A1.5 1.5 0 0 1 22.5 6v12a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 18V6A1.5 1.5 0 0 1 3 4.5z"
  }));
};

StoreIcon.displayName = 'StoreIcon';
export default StoreIcon;